// src/pages/dashboard/feature/MenuStyles.js
export const menuStyles = {
  paper: (paperShadow) => ({
    mt: 1,
    borderRadius: 2,
    boxShadow: paperShadow,
  }),
};